 
import { createAsyncThunk,createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  fileDowload,
  lotDetails,
  lotFileDownload,
  lotList,
  sponsorBylotPayload,
  uploadFileParams,
  zeroFileParams,
} from 'models/file';
import { reduxTemplate } from 'models/redux';
import { defaultResponse } from 'models/response';

import {
  getLotDetails,
  getLotList,
  getUsuariosAcDc,
  getZeroFile,
  postDataFile,
  postProcessingBySponsor,
} from './service';

export const getLots = createAsyncThunk<lotList>(
  'files/lotList',
  async (_, { rejectWithValue }) => {
    try {
      const data = await getLotList();
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err.response?.data);
    }
  }
);

export const getLotByLotNumber = createAsyncThunk<lotDetails, number>(
  'files/lotDetails',
  async (lotNUmber, { rejectWithValue }) => {
    try {
      const data = await getLotDetails(lotNUmber);
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err.response?.data);
    }
  }
);

export const getDocumentZeroFile = createAsyncThunk<
  fileDowload,
  zeroFileParams
>('files/fileStandardZero', async (payload, { rejectWithValue }) => {
  try {
    const data = await getZeroFile(payload);
    return data;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err.response?.data);
  }
});

export const getLotFile = createAsyncThunk<fileDowload, lotFileDownload>(
  'files/lotFile',
  async (payload, { rejectWithValue }) => {
    try {
      const data = await getUsuariosAcDc(payload);
      return data;
    } catch (error) {
      const err = error as AxiosError;
      return rejectWithValue(err.response?.data);
    }
  }
);

export const postUploadFile = createAsyncThunk<
  defaultResponse,
  uploadFileParams
>('files/readerFiles', async (payload, { rejectWithValue }) => {
  try {
    const data = await postDataFile(payload);
    return data;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err.response?.data);
  }
});

export const postProcessing = createAsyncThunk<
  defaultResponse,
  sponsorBylotPayload
>('files/processingBySponsor', async (payload, { rejectWithValue }) => {
  try {
    const data = await postProcessingBySponsor(payload);
    return data;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err.response?.data);
  }
});

interface IFilesReducer extends reduxTemplate {
  downloadFile: fileDowload;
  uploadFile: defaultResponse;
  lots: lotList;
  lotDetails: lotDetails;
}

const initialState: IFilesReducer = {
  status: 'idle',
  message: '',
  type: '',
  downloadFile: {
    status: 'idle',
    message: '',
    rowsAffected: [],
    document: [],
  },
  uploadFile: {
    status: 'idle',
    message: '',
    rowsAffected: [],
    document: [],
  },
  lots: {
    status: 'idle',
    message: '',
    rowsAffected: [],
    document: [],
  },
  lotDetails: {
    status: 'idle',
    message: '',
    rowsAffected: [],
    document: [],
  },
};

export const fileReducer = createSlice({
  name: 'file',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentZeroFile.pending, (state, action) => {
        state.status = 'loading';
        state.type = action.type;
      })
      .addCase(getDocumentZeroFile.fulfilled, (state, action) => {
        state.status = 'completed';
        state.message = action.payload.message;
        state.downloadFile = action.payload;
        state.type = action.type;
      })
      .addCase(getDocumentZeroFile.rejected, (state, action) => {
        state.status = 'failed';
        state.type = action.type;
      })
      .addCase(postUploadFile.pending, (state, action) => {
        state.status = 'loading';
        state.type = action.type;
      })
      .addCase(postUploadFile.fulfilled, (state, action) => {
        state.status = 'completed';
        state.message = action.payload.message;
        state.uploadFile = action.payload;
        state.type = action.type;
      })
      .addCase(postUploadFile.rejected, (state, action) => {
        state.status = 'failed';
        state.type = action.type;
      })
      .addCase(getLots.pending, (state, action) => {
        state.status = 'loading';
        state.type = action.type;
      })
      .addCase(getLots.fulfilled, (state, action) => {
        state.status = 'completed';
        state.message = action.payload.message;
        state.lots = action.payload;
        state.type = action.type;
      })
      .addCase(getLots.rejected, (state, action) => {
        state.status = 'failed';
        state.type = action.type;
      })
      .addCase(getLotByLotNumber.pending, (state, action) => {
        state.status = 'loading';
        state.type = action.type;
      })
      .addCase(getLotByLotNumber.fulfilled, (state, action) => {
        state.status = 'completed';
        state.message = action.payload.message;
        state.lotDetails = action.payload;
        state.type = action.type;
      })
      .addCase(getLotByLotNumber.rejected, (state, action) => {
        state.status = 'failed';
        state.type = action.type;
      });
  },
});

export default fileReducer.reducer;
